import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-full lg:w-1/3 pr-10" }
const _hoisted_2 = { class: "text-lg leading-6 font-medium" }
const _hoisted_3 = { class: "text-sm leading-5 font-normal text-gray-500 mt-1" }
const _hoisted_4 = { class: "w-full mt-3 lg:mt-0 lg:w-2/3 lg:pl-10" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "text-red-600 text-sm mt-2"
}
const _hoisted_7 = {
  key: 1,
  class: "flex"
}
const _hoisted_8 = { class: "w-1/2 lg:1/3 pr-2 relative" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "minimumAmount",
  class: "block text-sm font-medium text-gray-700 mb-2"
}, " Minimum amount ", -1)
const _hoisted_10 = { class: "relative w-full" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "$")
], -1)
const _hoisted_12 = { class: "w-1/2 lg:1/3 pr-2 relative" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "maximumAmount",
  class: "block text-sm font-medium text-gray-700 mb-2"
}, " Maximum amount ", -1)
const _hoisted_14 = { class: "relative w-full" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "$")
], -1)
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { class: "flex items-center justify-start mb-2" }
const _hoisted_19 = { class: "text-base leading-6 font-semibold" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "flex flex-wrap" }
const _hoisted_22 = { class: "flex items-center h-5" }
const _hoisted_23 = ["id", "name", "onClick", "checked"]
const _hoisted_24 = { class: "ml-3 text-sm" }
const _hoisted_25 = ["for"]
const _hoisted_26 = { key: 4 }
const _hoisted_27 = { class: "mt-2 lg:mt-0 px-5 py-4 flex lg:justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountiesSelector = _resolveComponent("CountiesSelector")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"])),
    class: "divide-y"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, ({ title, subtitle }, model) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "lg:flex p-6",
        key: model
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h4", _hoisted_2, _toDisplayString(title), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(subtitle), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (model == 'name')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["border rounded-md h-10 w-full text-sm px-3 max-w-md", { 'border-red-600': _ctx.invalidName }]),
                  id: "maximumAmount",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.collectedData.name) = $event)),
                  placeholder: "New product"
                }, null, 2), [
                  [_vModelText, _ctx.collectedData.name]
                ]),
                (_ctx.collectedData.name && _ctx.invalidName)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, " This product name is already in use "))
                  : _createCommentVNode("", true)
              ]))
            : (model == 'amountRange')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "border rounded-md h-10 w-full text-sm px-3 pl-6",
                        id: "minimumAmount",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.collectedData.minimumAmount) = $event)),
                        placeholder: ""
                      }, null, 512), [
                        [_vModelText, _ctx.collectedData.minimumAmount]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "border rounded-md h-10 w-full text-sm px-3 pl-6",
                        id: "maximumAmount",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collectedData.maximumAmount) = $event)),
                        placeholder: ""
                      }, null, 512), [
                        [_vModelText, _ctx.collectedData.maximumAmount]
                      ])
                    ])
                  ])
                ]))
              : (model == 'notes')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("textarea", {
                      class: "border rounded-md w-full text-sm px-3 max-w-md py-2",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.collectedData.notes) = $event)),
                      rows: "6"
                    }, null, 512), [
                      [_vModelText, _ctx.collectedData.notes]
                    ])
                  ]))
                : (['executionTypes', 'propertyTypes'].includes(model))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options[model], (list, key) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: key,
                          class: "mb-6"
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("h4", _hoisted_19, _toDisplayString(list.description || key), 1),
                            _createElementVNode("button", {
                              class: "text-xs bg-gray-200 text-dark rounded-md cursor-pointer px-3 py-1 ml-2 opacity-40 hover:opacity-100",
                              onClick: ($event: any) => (_ctx.selectGroup(model, list.types)),
                              type: "button"
                            }, " Select ", 8, _hoisted_20)
                          ]),
                          _createElementVNode("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.types, (name, value) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "relative flex items-start mt-2 w-1/2 lg:w-1/3",
                                key: name
                              }, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("input", {
                                    id: value.toString(),
                                    "aria-describedby": "comments-description",
                                    name: model,
                                    type: "checkbox",
                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded",
                                    onClick: ($event: any) => (_ctx.updateValue(model, value)),
                                    checked: _ctx.collectedData[model].has(value)
                                  }, null, 8, _hoisted_23)
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("label", {
                                    for: value.toString(),
                                    class: "font-medium text-gray-700 cursor-pointer"
                                  }, _toDisplayString(name || value), 9, _hoisted_25)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (model == 'footprints')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createVNode(_component_CountiesSelector, {
                          onUpdated: _cache[4] || (_cache[4] = ($event: any) => (_ctx.collectedData.footprints = new Set($event))),
                          data: Array.from(_ctx.collectedData.footprints)
                        }, null, 8, ["data"])
                      ]))
                    : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_27, [
      (_ctx.canCancel)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "bg-gray-200 hover:bg-gray-300 text-sm rounded-md py-2 px-4 mr-2",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('submit')))
          }, " Cancel "))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "submit",
        class: _normalizeClass(["bg-sky text-white text-sm rounded-md py-2 px-4", { 'opacity-50 pointer-events-none': _ctx.invalidName }])
      }, " Save ", 2)
    ])
  ], 32))
}